export default "__VITE_ASSET__BbLnvf6b__"